module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (251).7fdd1aa8.jpg";